import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useParams, useLocation  } from 'react-router-dom';
import { Card, Button, Carousel, CardText } from 'react-bootstrap';
import { Play, Pause, Volume2, VolumeX, RotateCcw, RotateCw, Maximize, Minimize } from "lucide-react";
import ReactPlayer from 'react-player';
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";


function AnnouncementsProfile() {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [announcements, setAnnouncements] = useState([]);
  const [carouselStates, setCarouselStates] = useState([]);
  const { update } = useParams();
  const isVideo = (url) => {
  return /\.(mp4|mov|avi|mkv|webm)$/i.test(url);
};
 const [duration, setDuration] = React.useState(0);

  // console.log("ROUTE PARAMS:", update);
 const isMobile = /Mobi|Android/i.test(navigator.userAgent);



  // Refs: per announcement -> per video
  const playerRefs = useRef([]);
  const wrapperRefs = useRef([]);
  const inactivityTimeouts = useRef([]);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const res = await fetch(`https://bkf.onrender.com/BKFannouncements/${update}`)
        if (!res.ok) throw new Error('Failed to fetch announcements');
        const data = await res.json();
        setAnnouncements(data);
        setIsLoaded(true);

       setCarouselStates(
  data.map((announcement) => {
    const itemCount = announcement.items?.length || 0;

    return {
      activeIndex: 0,
      isPlaying: Array(itemCount).fill(false),
      muted: Array(itemCount).fill(false),
      volume: Array(itemCount).fill(0.8),
      played: Array(itemCount).fill(0),
      showControls: true,
    };
  })
);

        // Initialize refs
       playerRefs.current = data.map((announcement) =>
  (announcement.items || []).map(() => React.createRef())
);

wrapperRefs.current = data.map((announcement) =>
  (announcement.items || []).map(() => React.createRef())
);
      } catch (err) {
        setError(err.message);
      }
    };
    fetchAnnouncements();
  }, [update]);

  const resetInactivityTimer = useCallback((annIndex) => {
    setCarouselStates(prev => prev.map((s, i) => i === annIndex ? { ...s, showControls: true } : s));
    if (inactivityTimeouts.current[annIndex]) clearTimeout(inactivityTimeouts.current[annIndex]);
    inactivityTimeouts.current[annIndex] = setTimeout(() => {
      setCarouselStates(prev => prev.map((s, i) => i === annIndex ? { ...s, showControls: false } : s));
    }, 3000);
  }, []);

const handlePlayPause = (annIndex, videoIndex) => {
  setCarouselStates(prev =>
    prev.map((s, i) =>
      i === annIndex
        ? {
            ...s,
            isPlaying: (() => {
              const arr = [...(s.isPlaying || [])];
              arr[videoIndex] = !arr[videoIndex];
              return arr;
            })(),
            activeIndex: videoIndex
          }
        : s
    )
  );
};

  const handleMute = (annIndex) => {
    setCarouselStates(prev => prev.map((s, i) => i === annIndex ? { ...s, muted: !s.muted } : s));
  };

  const handleSeek = (annIndex, videoIndex, fraction) => {
    const player = playerRefs.current[annIndex][videoIndex].current;
    if (player) {
      player.seekTo(fraction, 'fraction');
      setCarouselStates(prev =>
        prev.map((s, i) => i === annIndex ? { ...s, played: s.played.map((pl, j) => j === videoIndex ? fraction : pl) } : s)
      );
    }
  };

  const handleForward15 = (annIndex, videoIndex) => {
    const player = playerRefs.current[annIndex][videoIndex].current;
    if (!player) return;
    const duration = player.getDuration();
    const currentTime = player.getCurrentTime();
    handleSeek(annIndex, videoIndex, Math.min(1, (currentTime + 15)/duration));
  };

  const handleRewind15 = (annIndex, videoIndex) => {
    const player = playerRefs.current[annIndex][videoIndex].current;
    if (!player) return;
    const duration = player.getDuration();
    const currentTime = player.getCurrentTime();
    handleSeek(annIndex, videoIndex, Math.max(0, (currentTime - 15)/duration));
  };

const handleFullscreen = async (annIndex, videoIndex) => {
  const wrapperEl = wrapperRefs.current[annIndex][videoIndex]?.current;
  if (!wrapperEl) return;

  if (!document.fullscreenElement) {
    await wrapperEl.requestFullscreen?.();
  } else {
    await document.exitFullscreen?.();
  }
};

  const formatTime = (seconds = 0) => {
    seconds = Math.max(0, Math.floor(seconds));
    const m = Math.floor(seconds / 60).toString().padStart(2, "0");
    const s = Math.floor(seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

   const CF_BASE = "https://d2b3xd88n081z3.cloudfront.net";

  if (error) return <div>Error: {error}</div>;
  if (!isLoaded) return (
    <div 
                  style={{ 
                    height:"100vh",
                    marginTop: "30%",
                    marginRight: "25%",
                    marginLeft: "25%" 
                    }}>
                      <Card className="card-body"
                       style={{ 
                    textAlign: "center", 
                    }}
                      >
                        <h1>Loading...</h1>
                      </Card>
                  </div>
  );


  return (
    <div     style={{
    display: 'block',
    width: '95%',       
    maxWidth: '1000px',  
    margin: '0 auto',   
    height: 'auto',
    boxSizing: 'border-box',
    marginTop: '7%',
    marginBottom: '7%',
     
  }}>


        <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: -1,
              }}
               >
        <source 
        // src={BG} type="video/mp4" 
        src={`${CF_BASE}/public/backgroundgrey2.mp4`} 
        />
        
            Your browser does not support the video tag.
        </video>
        
      <div >
        {announcements.map((ann, annIndex) => {
          const state = carouselStates[annIndex] || {};
          const mediaList = [ann.media1, ann.media2].filter(Boolean);

          return (
            <React.Fragment key={annIndex}>
              <Card>
                     <div 
              style={{
                   backgroundColor: 'rgba(20, 19, 19, 0.7)',
                backdropFilter: 'blur(8px)',
                WebkitBackdropFilter: 'blur(8px)',
                padding: '10px',
                borderRadius: '8px', 
                 }}
                >
                  <div className='d-flex justify-content-center'
                  style={{ marginTop: '3%' }}
                  >
                    
                    <h7 className='d-flex px-3 px-md-5  justify-content-center'>{ann.Update}</h7>
                  </div>
                  
                  <h4 
                style={{ marginTop: '3%',
                 }}
                >{ann.date}</h4>
               <div>
              {Array.isArray(ann.content) ? (
                // ✅ NEW FORMAT
                ann.content.map((block, i) => {
                if (block.type === "text") {
              const isHTML = /<\/?[a-z][\s\S]*>/i.test(block.value);

              return isHTML ? (
                <div
                  key={i}
                  dangerouslySetInnerHTML={{ __html: block.value }}
                />
              ) : (
                <ReactMarkdown key={i}
                 rehypePlugins={[rehypeRaw]}
                remarkPlugins={[remarkGfm]}
                >
                  {block.value}
                </ReactMarkdown>
              );
            }

     if (block.type === "image") {
  const isPDF = block.value?.toLowerCase().endsWith('.pdf');

  if (isPDF) {
    return (
      <div key={i} style={{ margin: "16px 0" }}>
        <a className="hover-brighten"
          href={block.value}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            padding: "5px 10px",
            textDecoration: "none",
            fontWeight: "bold",
            fontSize: "clamp(12px, 1.8vmax, 18px)",
            color: "silver",
            backgroundColor: 'rgba(20,19,19,0.9)',
            borderRadius: '12px',
            border: '2px solid rgb(179,37,25)',
            boxShadow: '0 0 5px rgba(243,174,61,0.6), 0 0 10px rgba(243,174,61,0.35)',
          }}
        >
          📄 View Article (PDF)
        </a>
      </div>
    );
  }

  return (
    <div
      key={i}
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <img
        src={block.value}
        alt=""
        style={{
          maxWidth: "70%",
          maxHeight: "100%",
          objectFit: "contain",
        }}
      />
    </div>
  );
}

      if (block.type === "heading") {
      const Tag = `h${Math.min(block.level || 4, 4)}`; // caps at h4
      return <Tag key={i}>{block.value}</Tag>;
    }

        if (block.type === "link") {
      return (
        <div key={i} style={{ margin: "16px 0" }}>
          <a                                         
            className="hover-brighten"
            href={block.value}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              padding: "5px 10px",
              textDecoration: "none",
              fontWeight: "bold",
              fontSize: "clamp(12px, 1.8vmax, 18px)",
              color: "silver",
              backgroundColor: 'rgba(20,19,19,0.9)',
              borderRadius: '12px',
              border: '2px solid rgb(179,37,25)',
              boxShadow: '0 0 5px rgba(243,174,61,0.6), 0 0 10px rgba(243,174,61,0.35)',
            }}
          >
            {block.label || "View Link"}
          </a>                                       
        </div>
      );
    }

  if (block.type === "video") {
  const playerRef =
    playerRefs.current[annIndex]?.[0] ||
    (playerRefs.current[annIndex][0] = React.createRef());

  const wrapperRef =
    wrapperRefs.current[annIndex]?.[0] ||
    (wrapperRefs.current[annIndex][0] = React.createRef());

  const state = carouselStates[annIndex] || {};
  const playedFraction = state.played?.[0] || 0;

  const player = playerRef?.current;
  const duration = player?.getDuration?.() || 0;
  const currentTime = player?.getCurrentTime?.() || 0;

  return (
    <div
      key={i}
      className="netflix-player-wrapper"
      ref={wrapperRef}
      style={{ margin: "20px 0" }}
      onMouseEnter={() => resetInactivityTimer(annIndex)}
      onMouseMove={() => resetInactivityTimer(annIndex)}
      onMouseLeave={() =>
        setCarouselStates(prev =>
          prev.map((s, i) =>
            i === annIndex ? { ...s, showControls: false } : s
          )
        )
      }
    >
      <ReactPlayer
        ref={playerRef}
        url={block.value}
        playing={state.activeIndex === 0 && state.isPlaying?.[0]}
        volume={state.volume?.[0] ?? 0.8}
        muted={state.muted?.[0] ?? false}
        controls={isMobile}
        config={{
          file: {
            attributes: {
              playsInline: isMobile,
              controls: isMobile,
              disablePictureInPicture: !isMobile,
            },
          },
        }}
        width="100%"
        height="100%"
        onProgress={(p) => {
          setCarouselStates(prev =>
            prev.map((s, i) =>
              i === annIndex
                ? {
                    ...s,
                    played: (() => {
                      const updated = [...(s.played || [])];
                      updated[0] = p.played;
                      return updated;
                    })(),
                  }
                : s
            )
          );
        }}
      />

      {!isMobile && state.showControls && (
        <div
          className="netflix-controls"
          style={{ bottom: "0px", display: "flex", alignItems: "center", justifyContent: "center", gap: "20px", padding: "10px 20px", width: "100%", maxWidth: "100vw", zIndex: 10 }}
        >
          <div
            style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "5%", position: "absolute", bottom: "90%", width: "100%", zIndex: 2 }}
          >
            <Button
              onClick={() => handleRewind15(annIndex, 0)}
              style={{ backgroundColor: "transparent", border: "none", color: "white", cursor: "pointer", position: "relative", width: "48px", height: "48px", padding: 0, margin: "2%" }}
            >
              <RotateCcw size={48} strokeWidth={2.5} style={{ color: "silver", position: "absolute", top: 0, left: 0 }} />
              <span style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", fontSize: "14px", color: "white", pointerEvents: "none" }}>15</span>
            </Button>

            <Button
              className="center-play-button"
              onClick={() => handlePlayPause(annIndex, 0)}
              style={{ backgroundColor: "transparent", color: "white", border: "none", padding: "20px", borderRadius: "50%", cursor: "pointer", fontSize: "100px", zIndex: 2 }}
            >
              {state.isPlaying?.[0]
                ? <Pause fill="currentColor" size={64} strokeWidth={2.5} style={{ color: "silver" }} />
                : <Play fill="currentColor" size={64} strokeWidth={2.5} style={{ color: "silver" }} />
              }
            </Button>

            <Button
              onClick={() => handleForward15(annIndex, 0)}
              style={{ backgroundColor: "transparent", border: "none", color: "white", cursor: "pointer", position: "relative", width: "48px", height: "48px", padding: 0, margin: "2%" }}
            >
              <RotateCw size={48} strokeWidth={2.5} style={{ color: "silver", position: "absolute", top: 0, left: 0 }} />
              <span style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", fontSize: "14px", color: "white", pointerEvents: "none" }}>15</span>
            </Button>
          </div>

          <div className="sliders-container" style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", width: "100%", padding: "0 20px" }}>
            <input
              className="player-slider"
              type="range"
              min={0}
              max={1}
              step={0.01}
              value={playedFraction}
              onChange={(e) => handleSeek(annIndex, 0, parseFloat(e.target.value))}
              style={{ "--played": playedFraction }}
            />

            <div className="time-display">
              <CardText>{formatTime(currentTime)}/{formatTime(duration)}</CardText>
            </div>

            <div className="volume-wrapper" style={{ position: "relative" }}>
              <div
                onClick={() =>
                  setCarouselStates(prev =>
                    prev.map((s, i) =>
                      i === annIndex
                        ? {
                            ...s,
                            muted: (() => {
                              const arr = [...(s.muted || [])];
                              arr[0] = !arr[0];
                              return arr;
                            })(),
                          }
                        : s
                    )
                  )
                }
                style={{ cursor: "pointer" }}
              >
                {state.muted?.[0] || state.volume?.[0] === 0
                  ? <VolumeX color="silver" />
                  : <Volume2 color="silver" />
                }
              </div>
              <input
                type="range"
                min={0}
                max={1}
                step={0.01}
                value={state.volume?.[0] ?? 0.8}
                onChange={(e) => {
                  const newVolume = parseFloat(e.target.value);
                  setCarouselStates(prev =>
                    prev.map((s, i) =>
                      i === annIndex
                        ? {
                            ...s,
                            volume: (() => {
                              const arr = [...(s.volume || [])];
                              arr[0] = newVolume;
                              return arr;
                            })(),
                            muted: (() => {
                              const arr = [...(s.muted || [])];
                              arr[0] = newVolume === 0;
                              return arr;
                            })(),
                          }
                        : s
                    )
                  );
                }}
                className="custom-slider volume-slider"
                style={{ position: "absolute", bottom: "80px", left: "50%", transform: "translateX(-50%) rotate(-90deg)", width: "110px", height: "8px", zIndex: 10, "--progress": `${(state.volume?.[0] ?? 0.8) * 100}%` }}
              />
            </div>

            <div onClick={() => handleFullscreen(annIndex, 0)} style={{ cursor: "pointer" }}>
              {document.fullscreenElement === wrapperRef.current
                ? <Minimize color="silver" />
                : <Maximize color="silver" />
              }
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

if (block.type === "imageRow") {
  return (
    <div
      key={i}
      style={{
        display: "flex",
        gap: "20px",
        width: "70%",
        margin: "20px 0",
        flexWrap: "nowrap"  // or just remove this line entirely
      }}
    >
      {block.items.map((item, idx) => (
        <img
          key={idx}
          src={item.value}
          alt=""
          style={{
            flex: "1 1 0",      // each image grows/shrinks equally
            minWidth: 0,        // prevents images from overflowing
            borderRadius: "8px",
            objectFit: "cover"
          }}
        />
      ))}
    </div>
  );
}

if (block.type === "carousel") {
  return (
    <Carousel key={i} interval={null}>
      {block.items.map((item, idx) => {
        const isVid = isVideo(item.value);
        const videoIndex = idx;

        const playerRef =
          playerRefs.current[annIndex]?.[videoIndex] ||
          (playerRefs.current[annIndex][videoIndex] = React.createRef());

        const wrapperRef =
          wrapperRefs.current[annIndex]?.[videoIndex] ||
          (wrapperRefs.current[annIndex][videoIndex] = React.createRef());

        const state = carouselStates[annIndex] || {};
        const playedFraction = state.played?.[videoIndex] || 0;

        const player = playerRef?.current;
        const duration = player?.getDuration?.() || 0;
        const currentTime = player?.getCurrentTime?.() || 0;

        const url = item.value;

        return (
          <Carousel.Item key={idx}>
            <div
              className="netflix-player-wrapper"
              ref={wrapperRef}
              
              onMouseEnter={() => resetInactivityTimer(annIndex)}
              onMouseMove={() => resetInactivityTimer(annIndex)}
              onMouseLeave={() =>
                setCarouselStates(prev =>
                  prev.map((s, i) =>
                    i === annIndex ? { ...s, showControls: false } : s
                  )
                )
              }
            >
              {/* VIDEO OR IMAGE */}
              {isVid ? (
                <ReactPlayer
                  ref={playerRef}
                  url={url}
                 playing={
                    state.activeIndex === videoIndex &&
                    state.isPlaying?.[videoIndex]
                  }

                  volume={state.volume?.[videoIndex] ?? 0.8}
                  muted={state.muted?.[videoIndex] ?? false}
                  controls={isMobile}
                  config={{
                    file: {
                      attributes: {
                        playsInline: isMobile,
                        controls: isMobile,
                        disablePictureInPicture: !isMobile,
                      },
                    },
                  }}
                  width="100%"
                  height="100%"
                  onProgress={(p) => {
                    setCarouselStates(prev =>
                      prev.map((s, i) =>
                        i === annIndex
                          ? {
                              ...s,
                              played: (() => {
                                const updated = [...(s.played || [])];
                                updated[videoIndex] = p.played;
                                return updated;
                              })(),
                            }
                          : s
                      )
                    );
                  }}
                />
              ) : (
               <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <img
                  src={url}
                  alt=""
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain", // 👈 IMPORTANT for centering without cropping
                  }}
                />
              </div>
              )}

              {/* CONTROLS (ONLY IF VIDEO) */}
              {isVid &&
                !isMobile &&
                state.showControls &&
                state.showControls && !isMobile && (
                  <div
                    className="netflix-controls"
                    style={{
                      bottom: "0px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "20px",
                      padding: "10px 20px",
                      width: "100%",
                      maxWidth: "100vw",
                      zIndex: 10,
                    }}
                  >
                    {/* Play / Rewind / Forward */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "5%",
                        position: "absolute",
                        bottom: "90%",
                        width: "100%",
                        zIndex: 2,
                      }}
                    >
                      <Button
                        onClick={() =>
                          handleRewind15(annIndex, videoIndex)
                        }
                        style={{
                          backgroundColor: "transparent",
                          border: "none",
                          color: "white",
                          cursor: "pointer",
                          position: "relative",
                          width: "48px",
                          height: "48px",
                          padding: 0,
                          margin: "2%",
                        }}
                      >
                        <RotateCcw
                          size={48}
                          strokeWidth={2.5}
                          style={{
                            color: "silver",
                            position: "absolute",
                            top: 0,
                            left: 0,
                          }}
                        />
                        <span
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            fontSize: "14px",
                            color: "white",
                            pointerEvents: "none",
                          }}
                        >
                          15
                        </span>
                      </Button>

                      <Button
                        className="center-play-button"
                        onClick={() => handlePlayPause(annIndex, videoIndex)}
                        style={{
                          backgroundColor: "transparent",
                          color: "white",
                          border: "none",
                          padding: "20px",
                          borderRadius: "50%",
                          cursor: "pointer",
                          fontSize: "100px",
                          zIndex: 2,
                        }}
                      >
                     {state.isPlaying?.[videoIndex] ? (
                      <Pause
                        fill="currentColor"
                        size={64}
                        strokeWidth={2.5}
                        style={{ color: "silver" }}
                      />
                    ) : (
                      <Play
                        fill="currentColor"
                        size={64}
                        strokeWidth={2.5}
                        style={{ color: "silver" }}
                      />
                    )}
                      </Button>

                      <Button
                        onClick={() =>
                          handleForward15(annIndex, videoIndex)
                        }
                        style={{
                          backgroundColor: "transparent",
                          border: "none",
                          color: "white",
                          cursor: "pointer",
                          position: "relative",
                          width: "48px",
                          height: "48px",
                          padding: 0,
                          margin: "2%",
                        }}
                      >
                        <RotateCw
                          size={48}
                          strokeWidth={2.5}
                          style={{
                            color: "silver",
                            position: "absolute",
                            top: 0,
                            left: 0,
                          }}
                        />
                        <span
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            fontSize: "14px",
                            color: "white",
                            pointerEvents: "none",
                          }}
                        >
                          15
                        </span>
                      </Button>
                    </div>

                    {/* Seek / Volume / Time */}
                    <div
                      className="sliders-container"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "10px",
                        width: "100%",
                        padding: "0 20px",
                      }}
                    >
                      <input
                        className="player-slider"
                        type="range"
                        min={0}
                        max={1}
                        step={0.01}
                        value={playedFraction}
                        onChange={(e) =>
                          handleSeek(
                            annIndex,
                            videoIndex,
                            parseFloat(e.target.value)
                          )
                        }
                        style={{ "--played": playedFraction }}
                      />

                      <div className="time-display">
                        <CardText>
                          {formatTime(currentTime)}/
                          {formatTime(duration)}
                        </CardText>
                      </div>

                      {/* Volume */}
                      <div
                        className="volume-wrapper"
                        style={{ position: "relative" }}
                      >
                        <div
                        onClick={() =>
                        setCarouselStates(prev =>
                          prev.map((s, i) =>
                            i === annIndex
                              ? {
                                  ...s,
                                  muted: (() => {
                                    const arr = [...(s.muted || [])];
                                    arr[videoIndex] = !arr[videoIndex];
                                    return arr;
                                  })(),
                                }
                              : s
                          )
                        )
                      }
                          style={{ cursor: "pointer" }}
                        >
                          {state.muted?.[videoIndex] || state.volume?.[videoIndex] === 0 ? (
                            <VolumeX color="silver" />
                          ) : (
                            <Volume2 color="silver" />
                          )}
                        </div>

                        <input
                          type="range"
                          min={0}
                          max={1}
                          step={0.01}
                          value={state.volume?.[videoIndex] ?? 0.8}
                         onChange={(e) => {
                          const newVolume = parseFloat(e.target.value);

                          setCarouselStates(prev =>
                            prev.map((s, i) =>
                              i === annIndex
                                ? {
                                    ...s,
                                    volume: (() => {
                                      const arr = [...(s.volume || [])];
                                      arr[videoIndex] = newVolume;
                                      return arr;
                                    })(),
                                    muted: (() => {
                                      const arr = [...(s.muted || [])];
                                      arr[videoIndex] = newVolume === 0;
                                      return arr;
                                    })(),
                                  }
                                : s
                            )
                          );
                        }}
                          className="custom-slider volume-slider"
                          style={{
                            position: "absolute",
                            bottom: "80px",
                            left: "50%",
                            transform:
                              "translateX(-50%) rotate(-90deg)",
                            width: "110px",
                            height: "8px",
                            zIndex: 10,
                            "--progress": `${(state.volume?.[videoIndex] ?? 0.8) * 100}%`
                          }}
                        />
                      </div>

                      {/* Fullscreen */}
                      <div
                        onClick={() =>
                          handleFullscreen(annIndex, videoIndex)
                        }
                        style={{ cursor: "pointer" }}
                      >
                        {document.fullscreenElement ===
                        wrapperRef.current ? (
                          <Minimize color="silver" />
                        ) : (
                          <Maximize color="silver" />
                        )}
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </Carousel.Item>
        );
      })}
    </Carousel>
  );
}

      return null;
    })
  ) : (
    // ✅ OLD FORMAT (UNCHANGED)
    <ReactMarkdown>{ann.content}</ReactMarkdown>
  )}
</div>
                </div> 
              </Card>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}

export default AnnouncementsProfile;
